module.exports = __webpack_public_path__ + "img/data-object.e931f8e7.svg";